// extracted by mini-css-extract-plugin
export var divider = "_gx-7";
export var itemsToggle = "_gx-8";
export var mergeModal = "_gx-1";
export var optionCard = "_gx-4";
export var radioGroup = "_gx-6";
export var radioOption = "_gx-0";
export var selected = "_gx-5";
export var shipmentOptions = "_gx-2";
export var tableOptions = "_gx-3";